let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4fCJZ"), load("dTsOE"), load("7GU1S")]).then(() => parcelRequire('9lSmU'));